import { render, staticRenderFns } from "./questionType8.vue?vue&type=template&id=577558cf"
import script from "./questionType8.vue?vue&type=script&lang=js"
export * from "./questionType8.vue?vue&type=script&lang=js"
import style0 from "./questionType8.vue?vue&type=style&index=0&id=577558cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports